import SearchController from './search.controller';
import template from './search.html';
import './search.less';

const SearchContainer = {
  bindings: {},
  template,
  controller: SearchController
};

export default SearchContainer;



// WEBPACK FOOTER //
// ./src/containers/search/search.component.js